import React from "react";
import ManagerReportCell from "../managerReportCell/ManagerReportCell";
import { ScorecardGoal, ScorecardReportEntity } from "goalsCard/service/api/models";
import EntitiesReportTable from "shared/reports/components/reportsTable/EntitiesReportTable";
import { IReportElement, ITenantTableColumn } from "shared/reports/models/models";

interface ScoreReportsTableProps {
    reports: ScorecardReportEntity[];
    tenantTableColumns: ITenantTableColumn[];
}

const ScoreReportsTable: React.FC<ScoreReportsTableProps> = (props: ScoreReportsTableProps) => {
    const renderReportElement = (reportElement: IReportElement | undefined) => {
        const scoreCardGoal = reportElement as ScorecardGoal;
        return scoreCardGoal ? <ManagerReportCell report={scoreCardGoal} showTodayProgressValue={false} /> : <></>;
    };

    return (
        <EntitiesReportTable
            reportsEntities={props.reports}
            tenantTableColumns={props.tenantTableColumns}
            renderReportElement={renderReportElement}
        />
    );
};

export default ScoreReportsTable;
